import {
  pharmacyUnsubscribePostingReminders,
  professionalUnsubscribeInvitations,
  successSelector,
  UnsubscribeTypes,
  userActions,
} from '@pharmaplan/common';

import { classes } from '../../components/UnsubscribeInvitationEmails/styles';
import { useAppDispatch } from '../useAppDispatch';
import { useAppSelector } from '../useAppSelector';
import strings from '../../localization';

const { professionalBookingInvitation, pharmacyPostingReminder } = UnsubscribeTypes;

const useUnsubscribeInvitationEmails = (type: UnsubscribeTypes) => {
  const dispatch = useAppDispatch();

  const invitationUnsubscribeSuccess = useAppSelector((state) =>
    successSelector([userActions.professionalUnsubscribeInvitations], state));

  const postingReminderUnsubscribeSuccess = useAppSelector((state) =>
    successSelector([userActions.pharmacyUnsubscribePostingReminders], state));

  const url = new URL(globalThis.location.href);
  const id = url?.searchParams.get('id');

  const bookingInvitationUnsubscribe = () => {
    dispatch(professionalUnsubscribeInvitations(id ?? ''));
  };

  const postingReminderUnsubscribe = () => {
    dispatch(pharmacyUnsubscribePostingReminders(id ?? ''));
  };

  const unsubscribeApiConfig = {
    [professionalBookingInvitation]: bookingInvitationUnsubscribe,
    [pharmacyPostingReminder]: postingReminderUnsubscribe,
  };

  const labelsConfig = {
    [professionalBookingInvitation]: {
      title: strings.bookingInvitationEmails,
      desc: strings.toUnsubscribeClickBelow,
    },
    [pharmacyPostingReminder]: {
      title: strings.monthlyPostingReminder,
      desc: strings.toUnsubscribePostingReminder,
    },
  };

  const successConfig = {
    [professionalBookingInvitation]: invitationUnsubscribeSuccess,
    [pharmacyPostingReminder]: postingReminderUnsubscribeSuccess,
  };

  const { title, desc } = labelsConfig[type];

  const textsArray = [
    {
      key: 1,
      text: title,
      sx: classes.infoHeading,
    },
    {
      key: 2,
      text: desc,
      sx: classes.infoDesc,
    },
  ];

  return {
    textsArray,
    unsubscribe: unsubscribeApiConfig[type],
    success: successConfig[type],
  };
};

export default useUnsubscribeInvitationEmails;
